import axios from 'axios';

export interface IAxiosResp<T> {
  code: number;
  msg: string; // message
  success: boolean;
  data?: T;
  [key: string]: any;
}

const defaultConfig = {
  baseURL: ``,
};

const instance = axios.create(defaultConfig);

instance.interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

instance.interceptors.response.use(
  (resp) => {
    return resp.data?.data;
  },
  (err) => {
    return Promise.reject(err);
  }
);

export default instance;
